<footer class="w-full border-t border-gray-200 bg-background pb-2 pt-12 text-secondary-foreground">
  <div class="fluid-container flex w-full flex-col gap-8">
    <div class="grid grid-cols-1 gap-9 md:grid-cols-2">
      <div class="flex flex-col gap-8">
        <a class="flex items-center gap-2" [routerLink]="PAGE_ROUTES.HOME">
          <img src="assets/media/logos/logo.svg" alt="logo" class="h-8 w-auto object-contain"/>
          <span class="text-lg font-semibold">Sapec Software</span>
        </a>
        <div class="text-base">Transform your business with scalable web and mobile solutions.</div>

        <div class="flex max-w-[280px] flex-col gap-4">
          @for (contact of contacts(); track contact) {
            <div class="flex items-center gap-2">
              <lucide-icon [name]="contact.icon" size="20"></lucide-icon>
              <span class="text-sm">{{ contact.title }}</span>
            </div>
          }
        </div>
      </div>

      <div class="flex flex-col gap-8 md:flex-row md:justify-around">
        @for (category of categories(); track category; let i = $index) {
          <div class="flex flex-col gap-4">
            <span class="text-base font-semibold text-foreground">{{ category.title }}</span>
            <div class="flex flex-col gap-4">
              @if (i === 0) {
                <a class="w-fit cursor-pointer text-sm hover:text-primary" [href]="employeePortalUrl()" target="_blank">Employee
                  portal</a>
              }
              @for (item of category.items; track item) {
                <span [routerLink]="item.link"
                      class="w-fit cursor-pointer text-sm hover:text-primary">{{ item.title }}</span>
              }
              @if (i === 1) {
                <span class="w-fit cursor-pointer text-sm hover:text-primary" (click)="redirectToFAQ()">F.A.Q.</span>
              }
            </div>
          </div>
        }
      </div>
    </div>

    <div class="flex flex-col justify-between gap-8 border-t border-gray-200 py-10 lg:flex-row lg:gap-0">
      <div class="flex flex-wrap gap-2 text-base text-secondary-foreground">
        <span>Copyright © 2014-{{ currentYear }}, Sapec Software.</span><span> All Rights Reserved</span>
      </div>
      <div class="flex gap-5">
        @for (social of socials(); track social) {
          <a class="cursor-pointer text-gray-500 hover:text-gray-400" [href]="social.link" target="_blank">
            <span [inlineSVG]="social.icon"></span>
          </a>
        }
      </div>
    </div>
  </div>
</footer>
